import { render } from "./InquiryFlow.vue?vue&type=template&id=862a9d0c&scoped=true"
const script = {}

import "./InquiryFlow.vue?vue&type=style&index=0&id=862a9d0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862a9d0c"]])

export default __exports__